<template>
  <div class="service-list-normal">
    <psychometricChatStatus
      :loginUser="loginUser"
      :workStatus="workStatus"
      v-show="isOwner"
    ></psychometricChatStatus>
    <div class="xintan-qa" @click="goPaidQa">
      <p class="qa-text">心探教练·付费问答</p>
      <p class="qa-btn">向ta提问</p>
    </div>
    <div class="ceping-list-outer" v-if="cepingList.length">
      <p class="ceping-title">心探教练·测评解读</p>
      <ul class="ceping-list">
        <li
          class="ceping-item"
          v-for="(item, index) in cepingList"
          :key="index"
          @click="heartSearchReserve(item)"
        >
          <div class="item-l">
            <div class="item-title">测评报告解读--{{ item.title }}</div>
            <div class="item-price" v-if="!undef(item.price)">
              ￥{{ genPrice(item) }}
            </div>
          </div>
          <div class="item-btn">预约</div>
        </li>
      </ul>
    </div>

    <agreement ref="Agreement" @agreement="psychicCoachAgreement"></agreement>
  </div>
</template>

<script>
import agreement from 'component/platform/homepage/common/agreement.vue'
import psychometricChatStatus from 'component/platform/homepage/normalUser/psychometricChatStatus.vue'
import homepageMixin from 'mixins/platfrom/homepageMixin.js'
import { checkPsychicOrder } from 'api/platform/homepage.js'
import BigNumber from 'bignumber.js'
import { isDef } from 'utils/tool.js'

export default {
  mixins: [homepageMixin],
  components: {
    psychometricChatStatus,
    agreement
  },
  data() {
    return {
      tempPsychicCoachServiceInfo: null
    }
  },
  computed: {
    workStatus() {
      const { work_status } = this.phychicServiceInfo
      return isDef(work_status) ? +work_status : null
    },
    phychicServiceInfo() {
      return this.$store.getters['homepage/phychicServiceInfo']
    },
    cepingList() {
      const { assess_analysis = [] } = this.phychicServiceInfo
      return assess_analysis
    },
    loginUser() {
      return this.$store.getters['loginUser']
    },
    authorUserId() {
      return this.$route.params.userId
    },
    isOwner() {
      return +this.loginUser.id === +this.authorUserId
    }
  },
  mounted() {
    this.isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)
  },
  methods: {
    genPrice(item) {
      let price = +item.price
      if (price > 0) {
        // 后端返回的是“分”，需转为"元"。使用bignumber.js解决JS计算中可能出现的精度问题
        const x = new BigNumber(price)
        const y = new BigNumber(100)
        return x.div(y).toFixed(2)
      } else {
        return price
      }
    },
    undef(val) {
      return val === undefined || val === null
    },
    async goPaidQa() {
      this.$trackEvent('newprofilepages_xiintan_quiz', {})
      await this.$store.dispatch('getUserInfo')
      if (this.isOwner) {
        this.$toast({
          text: '不能对自己进行该操作',
          zIndexTop: true
        })
        return
      }
      this.routerToStaic({
        path: '/heart-search/paid-qa-process',
        query: {
          user_id: this.authorUserId
        }
      })
    },
    goToHeartSearch(service) {
      this.routerToStaic({
        path: '/heart-search/create-order',
        query: {
          user_id: this.authorUserId,
          service_id: service.id,
          hideNavigationBar: 1
        }
      })
    },
    checkPsychicOrder() {
      return new Promise((resolve, reject) => {
        checkPsychicOrder({
          user_id: this.authorUserId
        })
          .then(({ code, data }) => {
            if (code === 0 && +data.service_agree === 1) {
              resolve()
            } else {
              reject()
            }
          })
          .catch(err => {
            console.log(err)
            reject()
          })
      })
    },
    psychicCoachAgreement(type) {
      const status = type === 'agree' ? true : false
      if (status && this.tempPsychicCoachServiceInfo) {
        this.goToHeartSearch(this.tempPsychicCoachServiceInfo)
        this.tempPsychicCoachServiceInfo = null
      }
    },
    async heartSearchReserve(service) {
      this.$trackEvent('newprofilepages_xiintan_cepingjiedu', {})

      await this.$store.dispatch('getUserInfo')
      if (this.isOwner) {
        this.$toast({
          text: '用户不能向本人申请教练服务',
          zIndexTop: true
        })
        return
      }

      if (this.mixinIsApp) {
        this.checkPsychicOrder()
          .then(() => {
            this.goToHeartSearch(service)
          })
          .catch(() => {
            this.tempPsychicCoachServiceInfo = service
            this.$refs.Agreement.toggleAgreement()
          })
        return
      }

      if (this.$platform.isWechat) {
        this.downloadApp()
      } else {
        let delay = 4000
        if (!this.isIOS) {
          delay = 2000
        }
        window.location.href = `yixinli://open_user_home?user_id=${this.authorUserId}`
        setTimeout(this.downloadApp, delay)
      }
    },
    downloadApp() {
      if (this.isIOS) {
        window.location.href =
          'https://itunes.apple.com/app/apple-store/id994051627?pt=1667142&ct=bk&mt=8'
      } else {
        window.location.href = `https://m.xinli001.com/download`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~lib/scss/functions.scss';

.service-list-normal {
  margin-top: 30px;
  .xintan-qa {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 36px;
    box-sizing: border-box;
    width: 686px;
    height: 132px;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px #ebefff;
    border-radius: 30px;
    margin-bottom: 30px;
    .qa-text {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #21252d;
    }
    .qa-btn {
      width: 298px;
      height: 80px;
      background: linear-gradient(180deg, #bdc9fd 0%, #5d70f9 100%);
      border-radius: 40px;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .ceping-list-outer {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 40px 0px #ebefff;
    border-radius: 30px;
    padding: 40px 30px;
    box-sizing: border-box;
    .ceping-title {
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #21252d;
      margin-bottom: 30px;
    }
    .ceping-list {
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .ceping-item {
      width: 626px;
      height: 136px;
      background: #f8f9ff;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      padding: 0 28px;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
      .item-title {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6982fa;
        margin-bottom: 6px;
        max-width: 400px;
        @include limitLine(1);
      }
      .item-price {
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffa202;
      }
      .item-btn {
        width: 115px;
        height: 53px;
        background: linear-gradient(225deg, #869bff 0%, #627dff 100%);
        border-radius: 27px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
